<template>
  <div style="padding:0 0 16px 0">
    <Record v-if="record.id" :record="record" @cancel="record = {}" />
    <div v-else>
      <a-row>
        <div style="display: flex;align-items: center;">
          <a-col :span="20">
            <div class="form-group-list">
              <InputField style="width:60%;" label="编号" type="text" id="name" :modelValue="form.code"
                          placeholder="请输入编号" labelWidth="25%"
                          @update:modelValue="(value) => handleModelValueUpdate('code', value)"
              />
              <a-space>
                  <ButtonField text="查询" @click="query" secondary/>
                  <ButtonField text="重置" primary @click="reset"/>
              </a-space>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="right" style="margin-top: 4px">
               <ButtonField text="新增" primary @click="setView('新增截流井')"/>
            </div>
          </a-col>
        </div>
      </a-row>

      <div style="padding-bottom: 16px"></div>
        <Tablelist
                :showCheckbox="false"
                :list="list"
                :columns="tableColumns"
                :totalSize="totalSize"
                :totalPages="totalPages"
                :pageNum="pageNum"
                :pageSize="pageSize"
                @page-change="onChange"
        >
            <template #template-code="{ item }">
                <a href="#" @click.prevent="select(item)">{{ item.code }}</a>
            </template>
            <template #template-subType="{ item }">
                <DataDictFinder dictType="cutoffWellType" :dictValue="item.subType" />
            </template>
            <template #template-status="{ item }">
                <DataDictFinder dictType="status" :dictValue="String(item.status)" iconType="text" />
            </template>
            <template v-slot:actions="{ item }">
                <a-space>
                    <a @click.prevent="setRecord(item)">维保记录</a>
                    <a @click.prevent="edit(item)">编辑</a>
                    <a class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
      <div v-if="list.length === 0" style="padding-bottom: 16px"></div>
    </div>
  </div>
</template>
<script>
import { fetchList, del } from "@/api/assets/interceptWell";
import Record from "./record.vue";
import store from '../mixins/store'
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
import Tablelist from "@/components/water-affairs-style/table-list.vue";

export default {
  mixins: [store],
  components: {
      Tablelist,
      ButtonField,
      InputField,
    Record,
  },

  data() {
    return {
      form: {},
      list: [],
      loading: false,
      totalSize: 1,
      totalPages: 1,
      pageNum: 1,
      pageSize: 10,
      record: {},
      tableColumns:[
          {
              key: 'code',
              title: '编号',
              field: 'code',
              infotype: 'text',
              width: '100px'
          },
          {
              key: 'name',
              title: '名称',
              field: 'name',
              infotype: 'text',
              width: '250px'
          },
          {
              key: 'subType',
              title: '分类',
              field: 'subType',
              infotype: 'template',
              width: '150px'
          },
          {
              key: 'status',
              title: '状态',
              field: 'status',
              infotype: 'template',
              width: '100px'
          },
          {
              key: 'sn',
              title: '唯一标识',
              field: 'sn',
              infotype: 'text',
              width: '150px'
          },
          {
              key: 'location',
              title: '位置',
              field: 'location',
              infotype: 'text',
              width: '150px'
          },
          {
              key: 'actions',
              title: '操作',
              infotype: 'template',
              width: '200px',
              fixed: 'right',
          }
      ]
    };
  },
  mounted() {
    this.getList();
  },

  methods: {
    handleModelValueUpdate(fieldName, value) {
        this.form[fieldName] = value;
    },
    handleAction(actionInfo) {
        const { type,  id,item } = actionInfo;
        switch(type) {
            case 'edit':
                this.edit(item);
                break;
            case 'custom':
                this.setRecord(item);
                break;
            case 'delete':
                this.deleteText(id);
                break;
        }
    },
    getList() {
      this.loading = true;
      let { form } = this;

      fetchList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.totalSize = res.totalSize;
            this.totalPages = res.totalPages;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.pageNum  = pagination;
      this.pageSize = 10;
      this.getList();
    },
    reset() {
      this.form = {};
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },
    query() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },

    edit(row) {
      this.select({
        ...row,
        _edit: true,
      });
      this.setView('修改截流井')
    },

    select(row) {
      this.setSelectedWell({
        ...row,
        _change: true,
      });
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除这个截流井吗？",
        onOk() {
          del({
            id: text.id,
          }).then(() => {
            that.getList();
            that.getFacilityList();
          });
        },
      });
    },

    setRecord(text) {
      this.record = text;
    },
  },
};
</script>
<style scoped>
.form-group-list{
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 70%;
}
</style>